import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { toast } from "sonner";
import { Send } from "lucide-react";
import api, { formatApiError } from "../api";
import { useT } from "../i18n";

export default function ContactDialog({ pro, open, onOpenChange }) {
  const { t } = useT();
  const [form, setForm] = useState({ parent_name: "", parent_contact: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post(`/pros/${pro.id}/contact`, form);
      toast.success(t("contact.success"));
      setForm({ parent_name: "", parent_contact: "", message: "" });
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full min-h-[48px] rounded-xl border border-[#0D4045]/15 bg-white px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D4045]/30";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="contact-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "Manrope" }}>{t("contact.title")} — {pro.name}</DialogTitle>
          <DialogDescription>{t("contact.disclaimer")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="flex flex-col gap-4 mt-2">
          <input data-testid="contact-name-input" value={form.parent_name} onChange={set("parent_name")}
            placeholder={t("contact.name")} required className={inputCls} />
          <input data-testid="contact-coord-input" value={form.parent_contact} onChange={set("parent_contact")}
            placeholder={t("contact.coord")} required className={inputCls} />
          <textarea data-testid="contact-message-input" value={form.message} onChange={set("message")}
            placeholder={t("contact.message")} required rows={4}
            className="w-full rounded-xl border border-[#0D4045]/15 bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D4045]/30" />
          <button type="submit" disabled={loading} data-testid="contact-submit-btn"
            className="flex items-center justify-center gap-2 min-h-[48px] bg-[#0D4045] text-[#FDFBF7] font-semibold rounded-full hover:bg-[#0a3237] transition-colors duration-200 disabled:opacity-60">
            <Send size={15} /> {loading ? "…" : t("contact.submit")}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
